import { Box, Button, Link, Tooltip } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import PurchaseHistoryFilter from "../../components/DialogBoxComponent/PurchaseHistoryFilter";
import UpGradeDialogBox from "../../components/DialogBoxComponent/UpGradeDialogBox";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { exportPurchaseListLogs } from "../../services/Invitations/ExportDealerService";
import { getPurchasedPlans } from "../../slices/Subscription/SubscriptionSlice";
import CommonUtil from "../../Util/CommonUtils";
import ExportDialog from "../DailyReports/ExportDialog";

function PlanPurchased() {
  const { t } = useTranslation();
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [clear, setClear] = React.useState(false);
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalRecords, setTotalRecords] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [openFilter, setOpenFilter] = useState(false);
  const [openexport, setOpenExport] = useState(false);
  const [openUpGrade, setOpenUpGrade] = useState(false);
  const [rowData, setRowData] = useState({});
  const [filter, setFilter] = useState({
    subscriptionName: "",
    planAssigned: "",
    startDate: "",
    endDate: "",
  });
  const [paging, setPaging] = useState({
    pageNumber: 1,
    pageSize: 50,
  });
  const [fileFormat, setFileFormat] = useState("1");
  const [noOfRecords, setNoOfRecords] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [isLivePhoto, setIsLivePhoto] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [closemodel, setClosemodel] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const defaultFilter = {
    subscriptionName: "",
    planAssigned: "",
    startDate: "",
    endDate: "",
  };

  const [offset, setOffset] = useState("");

  useEffect(() => {
    const getLocalOffset = () => {
      const now = new Date();
      const offsetMinutes = now.getTimezoneOffset();
      const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
      const offsetMinutesRemain = Math.abs(offsetMinutes) % 60;
      const sign = offsetMinutes > 0 ? "-" : "+";
      return `${sign}${String(offsetHours).padStart(2, "0")}:${String(
        offsetMinutesRemain
      ).padStart(2, "0")}`;
    };

    setOffset(getLocalOffset());
  }, []);

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging]);

  const loadData = (filter, paging) => {
    let payload = {
      pageNumber: paging.pageNumber,
      pageSize: paging.pageSize,
      subscriptionName: filter.subscriptionName,
      planAssigned: filter.planAssigned,
      startDate: filter.startDate,
      endDate: filter.endDate,
    };
    dispatch(getPurchasedPlans(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4035") {
          setLoading(false);
          setRows(res.data.purchasedPlans);
          setTotalPages(res.data.totalPages);
          setTotalRecords(res.data.totalCount);
          setPage(res.data.currentPage);
        } else {
          setLoading(false);
          setRows([]);
        }
      });
  };

  const handleFileFormatChange = (event) => {
    setFileFormat(event.target.value);
  };

  const handleDataRecordsChange = (event) => {
    setNoOfRecords(event.target.value);
  };

  const handleCheckBoxLivePhoto = (event) => {
    setIsLivePhoto(event.target.checked);
  };
  const handleCheckBoxSignature = (event) => {
    setIsSignature(event.target.checked);
  };
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setInputValue(value);
    }
  };

  const handleToInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setToInputValue(value);
    }
  };

  const handleExportCustomer = (data) => {
    if (fileFormat == "2") {
      setIsLivePhoto(false);
      setIsSignature(false);
    }
    var searchParam = "";
    if (
      filter.planAssigned !== undefined &&
      !CommonUtil.isEmptyString(filter.planAssigned)
    ) {
      searchParam += "&planAssigned=" + encodeURIComponent(filter.planAssigned);
    }
    if (
      filter.startDate !== undefined &&
      !CommonUtil.isEmptyString(filter.startDate)
    ) {
      searchParam += "&startDate=" + encodeURIComponent(filter.startDate);
    }
    if (
      filter.endDate !== undefined &&
      !CommonUtil.isEmptyString(filter.endDate)
    ) {
      searchParam += "&endDate=" + encodeURIComponent(filter.endDate);
    }
    searchParam += "&timeZone=" + encodeURIComponent(offset);
    searchParam +=
      "&datepattern=" + formatDate(companySettings?.adminAndDealerDateFormat);
    const stats = {
      fileType: fileFormat,
      from: inputValue === "" ? "0" : inputValue,
      to: toInputValue === "" ? "0" : toInputValue,
    };

    dispatch(exportPurchaseListLogs(onSuccess, onFailure, stats, searchParam))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((er) => {});
  };

  const onSuccess = () => {
    setClosemodel(true);
    return Toast(t("EXPORTSUCC001"), "success");
  };

  const onFailure = () => {
    Toast(t("COMMON000"), "error");
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 15) {
      return text.substring(0, 17) + "...";
    } else {
      return text;
    }
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "DD-MM-YYYY":
        return "dd-MM-yyyy HH:mm";
      case "MM-DD-YYYY":
        return "MM-dd-yyyy HH:mm";
      case "YYYY-MM-DD":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const handleSelect = (params) => {
    if (CommonUtil.isEmptyString(params.price)) {
      Toast(t("DUMMY_PLAN"), "error");
      return;
    }
    if (!params.planAssigned) {
      Toast(t("PLAN_NOT_ASSIGNED"), "error");
      return;
    }
    setRowData(params);
    setOpenUpGrade(!openUpGrade);
  };

  const renderCellStartDate = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.startDate)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : ""
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const renderCellEndDate = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.endDate)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : ""
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const columns = React.useMemo(
    () => [
      {
        field: "subscriptionName",
        headerName: t("SUBSCRIPTIONPLANNAME"),
        minWidth: 190,
        flex: 1,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.subscriptionName}`}
            placement="bottom-start"
          >
            <span>{handleTextOverflow(params.row.subscriptionName)}</span>
          </Tooltip>
        ),
      },
      {
        field: "startDate",
        headerName: t("FILTERSTARTDATE"),
        minWidth: 190,
        flex: 1,
        renderCell: renderCellStartDate(
          formatDate(companySettings?.adminAndDealerDateFormat)
        ),
      },
      {
        field: "endDate",
        headerName: t("FILTERENDDATE"),
        minWidth: 190,
        flex: 1,
        renderCell: renderCellEndDate(
          formatDate(companySettings?.adminAndDealerDateFormat)
        ),
      },
      {
        field: "price",
        headerName: t("CUSTDATABLE08"),
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          if (params.value && params.value.unit_amount_decimal != null) {
            return params.value.unit_amount_decimal / 100;
          }
          return null;
        },
      },
      {
        field: "discount",
        headerName: t("DISCOUNT"),
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          if (
            params.row.discount &&
            params.row.discount.discountValue != null
          ) {
            return `${params.row.discount.discountValue}%`;
          }
          return "";
        },
      },
      {
        field: "subscriptionMode",
        headerName: t("SUBSCRIPTIONMODE"),
        minWidth: 190,
        flex: 1,
        renderCell: (params) => {
          if (params.row.price && params.row.price.recurring) {
            if (params.row.price.recurring.interval === "year") {
              return t("YEARLY_UPPER_CASE");
            } else if (params.row.price.recurring.interval === "month") {
              return t("MONTHLY");
            }
          }
          return "";
        },
      },
      {
        field: "maxVisitsCreation",
        headerName: t("VISIT_COUNT"),
        minWidth: 190,
        flex: 1,
      },
      {
        field: "comapany",
        headerName: t("PLANASSIGNED"),
        minWidth: 170,
        flex: 1,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.assignedCompanyName}`}
            placement="bottom-start"
          >
            <span>{handleTextOverflow(params.row.assignedCompanyName)}</span>
          </Tooltip>
        ),
      },
      {
        field: "planAssigned",
        headerName: t("CUSTDATABLE07"),
        minWidth: 150,
        flex: 1,
        renderCell: (params) =>
          params.value ? t("PLAN_ASSIGNED") : t("PLAN_UN_ASSIGNED"),
      },
      {
        field: "Action",
        headerName: t("PLAN_ACTION"),
        type: "action",
        flex: 1,
        minWidth: 100,
        width: 100,
        headerAlign: "start",
        renderCell: (params) => (
          <Button
            className="rounded-button"
            sx={{
              backgroundColor: "#0F5A9C26",
              height: "5px",
              color: "#0F5A9C",
            }}
            onClick={() => handleSelect(params.row)}
          >
            {t("UPGARDE")}
          </Button>
        ),
      },
    ],
    [formatDate(companySettings?.adminAndDealerDateFormat)]
  );

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      ...paging,
      pageNumber: newPage,
      pageSize: size,
    });
  };

  const handlePlanFilter = () => {
    setOpenFilter(!openFilter);
  };

  const handleFilter = (data) => {
    setLoading(true);
    setClear(true);
    setFilter({
      ...filter,
      planAssigned:
        data.status === "Assigned"
          ? true
          : data.status === "Unassigned"
          ? false
          : "",
      startDate: CommonUtil.formatToUtc(data.startDate),
      endDate: CommonUtil.formatToUtc(data.endDate),
    });
    console.log(filter);
  };

  const resetFilter = () => {
    setLoading(true);
    setFilter({
      ...defaultFilter,
    });
    setClear(false);
  };

  const handleExport = () => {
    if (rows.length === 0) {
      // Toast(t("dataTableEmptyList"), "error");
      return;
    }
    setOpenExport(!openexport);
  };

  return (
    <>
      <HeaderToolbar title={t("PURCHASED_PLAN_HEADER")} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Tooltip title={t("COMMON006")}>
          <Box
            item
            className={"filter"}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handlePlanFilter}
          >
            {isHovered ? (
              <FilterIconHover style={{ color: "#474a4e" }} />
            ) : (
              <FilterIcon style={{ color: "#474a4e" }} />
            )}
          </Box>
        </Tooltip>

        <Box item onClick={handleExport}>
          <ExportDialog
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleExportCustomer(data)}
            totalRecords={totalRecords}
            nameTitle={"Export Purchased Plan"}
            handleFileFormatChange={handleFileFormatChange}
            handleDataRecordsChange={handleDataRecordsChange}
            handleInputChange={handleInputChange}
            handleToInputChange={handleToInputChange}
            fileFormat={fileFormat}
            noOfRecords={noOfRecords}
            inputValue={inputValue}
            toInputValue={toInputValue}
            setFileFormat={setFileFormat}
            setNoOfRecords={setNoOfRecords}
            setInputValue={setInputValue}
            setToInputValue={setToInputValue}
            setIsLivePhoto={setIsLivePhoto}
            setIsSignature={setIsSignature}
            isLivePhoto={isLivePhoto}
            isSignature={isSignature}
            handleCheckBoxLivePhoto={handleCheckBoxLivePhoto}
            handleCheckBoxSignature={handleCheckBoxSignature}
            dealerPortal={true}
            closemodel={closemodel}
            setClosemodel={setClosemodel}
          />
        </Box>

        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          pageSize={rowsPerPage}
          count={totalRecords}
          pageCount={totalPages}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openFilter && (
        <PurchaseHistoryFilter
          open={openFilter}
          handleClose={() => {
            setOpenFilter(false);
          }}
          onSave={handleFilter}
          date={formatDate(companySettings?.adminAndDealerDateFormat)}
        />
      )}

      {openUpGrade && (
        <UpGradeDialogBox
          open={openUpGrade}
          handleClose={() => {
            setOpenUpGrade(false);
            loadData(filter, paging);
          }}
          data={rowData}
        />
      )}
    </>
  );
}

export default PlanPurchased;
